import React, {Component} from 'react';
import SVGIcon from '../../../../../../assets/svg-icons/icons';
import Button from '../../../../../shared/library/Button/Button';
import {HandleShareClick} from '../../../../../shared/utilities/shareHelpers';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';
import moment from 'moment';
import './css/SocialButtons.styl';

export default class SocialButtons extends Component {
  emailServiceShareContents(options) {
    const formattedDate = moment.utc(options.serviceDate).format('MM/DD/YYYY');

    return {
      subject: `${options.serviceType} for ${
        options.fullName
      } on ${formattedDate}`,
      body:
        `Hello, %0D%0A%0D%0APlease join me at the ${options.serviceType} for ${
          options.fullName
        } on ${formattedDate}.%0D%0A%0D%0AFor complete details, visit ${
          options.obituaryUrl
        }` +
        `%0D%0A%0D%0AConsider sending hand-delivered sympathy flowers to those grieving a loss. ${encodeURIComponent(
          options.flowersUrl
        )}`,
    };
  }

  emailObituaryShareContents(options) {
    return {
      subject: `${options.fullName} Obituary - Legacy.com`,
      body: `This obituary I found on Legacy.com may interest you: ${
        options.obituaryUrl
      }`,
    };
  }

  getEmailContents(options) {
    if (options.type === 'service') {
      return this.emailServiceShareContents(options);
    }
    if (options.type === 'obituary') {
      return this.emailObituaryShareContents(options);
    }
    return {subject: '', body: ''};
  }

  emailShare = (event, options) => {
    const emailContents = this.getEmailContents(options);
    const emailUrl = `mailto:?subject=${emailContents.subject}&body=${
      emailContents.body
    }`.replace(' ', '%20');

    HandleShareClick(event, emailUrl, 'email', false);
  };

  handleSendFlowersClick = type => {
    const eventCategory = {
      service: 'fhd_obit',
      obituary: 'fhd_obit',
      default: 'flower',
    };
    const eventAction = {
      service: 'fhd_upcoming_flowers_click',
      obituary: 'fhd_flowers_click',
      default: 'flower',
    };
    const eventLabel = {
      service: 'fhd_obit_upcoming_flowers',
      obituary: 'fhd_obit_flowers',
      default: 'flower',
    };

    getGATags({
      eventCategory: eventCategory[type] || eventLabel.default,
      eventAction: eventAction[type] || eventLabel.default,
      eventLabel: eventLabel[type] || eventLabel.default,
    });
  };

  facebookShare = (event, options) => {
    const productionUrl = new URL(options.obituaryUrl);

    productionUrl.host = 'www.legacy.com';
    productionUrl.port = '';
    const sharerURL = `http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      productionUrl.href
    )}`;

    HandleShareClick(event, sharerURL, 'fb', false);
  };

  render() {
    const {obituaryUrl, flowersUrl} = this.props.urls;
    const {fullName, serviceType, serviceDate, isPlanning} = this.props.details;
    const facebookShareOptions = {obituaryUrl};
    const emailShareOptions = {
      type: this.props.type,
      fullName,
      serviceType,
      serviceDate,
      obituaryUrl,
      flowersUrl,
    };

    return (
      <div className="social-buttons">
        <div
          className="social-buttons__facebook small-button"
          onClick={event => this.facebookShare(event, facebookShareOptions)}
        >
          <SVGIcon
            className="social-buttons__fb-svg"
            name="facebook"
            size="18"
          />
          <span className="social-buttons__fb-span">Share</span>
        </div>
        <Button
          className="social-buttons__email"
          type="small-button"
          action={event => {
            this.emailShare(event, emailShareOptions);
          }}
        >
          Email
        </Button>
        {!isPlanning && (
          <Button
            className="btn social-buttons__flowers"
            type="btn"
            href={flowersUrl}
            action={() => {
              this.handleSendFlowersClick(this.props.type);
            }}
          >
            Send Flowers
          </Button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/SocialButtons/index.js